import { Link } from "react-router-dom";
import { newsCategories } from "@/mocks/newsCategories";

function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100 dark:text-foreground-900">
      <div className="w-full px-4 md:px-10 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500 text-secondary-950 font-heading text-xl font-black">
                瓜
              </span>
              <span className="font-heading text-xl font-black text-background-50 dark:text-foreground-950 tracking-wide">
                瓜圈速报
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 dark:text-foreground-800/80">
              把突发、最新进展和快讯集中同步，让每一次点开都快人一步。我们不制造话题，只把公开信息按时间线整理清楚，帮你抢在别人讨论之前看懂来龙去脉。
            </p>
            <p className="mt-5 text-xs text-background-300/70 dark:text-foreground-700/70">
              内容均为公开信息整理与再编排，涉及的人际关系判断请以当事人及官方回应为准。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 dark:text-foreground-950 mb-5 tracking-wide">
              主题速报
            </h4>
            <ul className="space-y-3 text-sm">
              {newsCategories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-200/80 dark:text-foreground-800/80 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 dark:text-foreground-950 mb-5 tracking-wide">
              站内导航
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-background-200/80 dark:text-foreground-800/80 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  首页速报
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-background-200/80 dark:text-foreground-800/80 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  全部快讯
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-200/80 dark:text-foreground-800/80 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="mailto:hi@guaspeed.example.com"
                  rel="nofollow"
                  className="text-background-200/80 dark:text-foreground-800/80 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  线索投稿：hi@guaspeed.example.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/10 dark:border-foreground-900/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-background-300/70 dark:text-foreground-700/70">
          <p>© {year} 瓜圈速报 · 第一手快讯持续更新中</p>
          <p className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500" />
            速报内容仅代表公开信息整理，不构成任何事实认定
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;